import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/niveles-fidelidad`;

export const getNivelesFidelidad = async (token) => {
    const response = await fetch(API_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar niveles de fidelidad');
    return response.json();
};

export const getNivelFidelidadById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener nivel de fidelidad');
    return response.json();
};

export const createNivelFidelidad = async (token, data) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear nivel de fidelidad');
    return response.json();
};

export const updateNivelFidelidad = async (token, id, data) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar nivel de fidelidad');
    return response.json();
};

export const deleteNivelFidelidad = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar nivel de fidelidad');
};

